module.exports = __webpack_public_path__ + "img/md-share-alt.aed8ca41.svg";